import _cloneDeep from 'lodash.clonedeep';
import _merge from 'lodash.merge';
import * as PlayerActionTypes from '../player/action-types.constants';
import * as MainActionTypes from '../action-types.constants';
import DEFAULT_PLAYLIST_ITEM from './playlist-item.json';

function getDefaultPlaylistItemState() {
    return _cloneDeep(DEFAULT_PLAYLIST_ITEM);
}

function getDefaultState() {
    const DEFAULT_STATE = {
        "series-path": "",
        "ifi-path": "/ifi-1",
        "items": []
    }
    return DEFAULT_STATE;
}

const Playlist = (state = getDefaultState(), action) => {
    let newState = {}

    const { type } = action;
    switch (type) {
        case MainActionTypes.INIT:
            (() => {
                const { episodes, seriesPath, ifiPath } = action;
                const playlist = episodes.map((episode, index) => {
                    const { title, episodeTag, comingsoon, thumbnail, video } = episode;
                    const { duration } = video;
                    return _merge(getDefaultPlaylistItemState(), {
                        videoId: `video${index+1}`,
                        comingsoon,
                        href: `${seriesPath}${episode.path}`,
                        title,
                        episodeTag,
                        thumbnail,
                        duration
                    });
                })
                newState = {
                    "series-path": seriesPath,
                    "ifi-path": ifiPath || state["ifi-path"],
                    "items": playlist
                }
            })();
            break;
        case MainActionTypes.ADD_IFI:
            (() => {
                const { config } = action;
                let newItems = [...state.items];
                //console.log("[PlaylistReducers] Add IFI:",config);
                const { pathname } = document.location;
                let currentIndex = newItems.findIndex(item => {
                    if (item.comingsoon === true) {
                        return false;
                    }

                    return item.href === pathname || `${item.href}/` === pathname;
                })
                const insertIndex = currentIndex < 1 ? 1 : currentIndex + 1;
                const { title, thumbnail, video } = action.config;
                const { duration } = video;
                const ifiPath = action.path || state["ifi-path"];
                let jobCode = "";
                if (config["job-code"] != null) {
                    if (window.innerWidth < 768) {
                        jobCode = config["job-code"].mobile;
                    } else if (window.innerWidth < 1224) {
                        jobCode = config["job-code"].tablet;
                    } else {
                        jobCode = config["job-code"].desktop;
                    }
                }
                const ifiConfig = _merge(getDefaultPlaylistItemState(), config, {
                    "videoId": "ifi-1",
                    isIfi: true,
                    "href": `${state["series-path"]}${ifiPath}`,
                    title,
                    thumbnail,
                    duration,
                    jobCode
                })
                newItems.splice(insertIndex, 0, ifiConfig);
                newState = {
                    "items": newItems
                }
            })();
            break;
        case PlayerActionTypes.PLAYER_EVENT_PLAYING:
        case PlayerActionTypes.PLAYER_EVENT_MEDIACHANGE:
            (() => {
                const items = state.items.map(item => {
                    let playing = item.videoId === action.data.videoId;
                    return Object.assign({}, item, {
                        "playing": playing
                    });
                });
                newState = {
                    items
                }
            })()
            break;
        case PlayerActionTypes.DESTROY_PLAYER:
            (() => {
                const items = state.items.map(item => {
                    return Object.assign({}, item, {
                        "playing": false
                    });
                });
                newState = {
                    items
                }
            })()
            break;
        case PlayerActionTypes.PLAYER_EVENT_ENDED:
            (() => {
                const items = state.items.map(item => {
                    let { watched } = item;
                    if (item.videoId === action.data.videoId) {
                        watched = true;
                    }
                    return Object.assign({}, item, {
                        "watched": watched,
                        "playing": false
                    });
                });
                newState = {
                    items
                }
            })()
            break;
        default:
            newState = state
    }

    if (newState !== state) {
        newState = Object.assign({}, state, newState);
    }
    return newState;
}

export default Playlist;